export const MIN_PASSWORD_LENGTH = 8;

const PASSWORD_SPECIAL_CHARS = /[@#$%^&*_\-!+=[\]{}|\\:',.?/`~"(); ]/;
export const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*_\-!+=[\]{}|\\:',.?/`~"(); ])[A-Za-z0-9@#$%^&*_\-!+=[\]{}|\\:',.?/`~"(); ]{8,256}$/;
export const SPECIAL_CHARS_HINT = '(@#$%^&*_-!+=[]{}|:\',.?/`~"(); )';

export const PASSWORD_REQUIREMENTS: ReadonlyArray<{ key: string; test: (value: string) => boolean }> = [
  { key: 'length', test: (value) => value.length >= MIN_PASSWORD_LENGTH },
  { key: 'uppercase', test: (value) => /[A-Z]/.test(value) },
  { key: 'lowercase', test: (value) => /[a-z]/.test(value) },
  { key: 'number', test: (value) => /[0-9]/.test(value) },
  { key: 'special', test: (value) => PASSWORD_SPECIAL_CHARS.test(value) },
];
